module.exports = __webpack_public_path__ + "static/media/shot-empty.354bbbf6.png";